import * as firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';
/*
var firebaseConfig = {
  apiKey: "AIzaSyDLmnoBvnjOQ-AaJgDw1DnVBiTETbcp8LI",
  authDomain: "the-net-ninja-sandbox.firebaseapp.com",
  databaseURL: "https://the-net-ninja-sandbox.firebaseio.com",
  projectId: "the-net-ninja-sandbox",
  storageBucket: "the-net-ninja-sandbox.appspot.com",
  messagingSenderId: "485942827092",
  appId: "1:485942827092:web:1811d9d8f1f5fabcd5b5c1"
};*/

const firebaseConfig = {
  apiKey: "AIzaSyAlWczTDivyErWnUcnC8Pfvq3G6Oc_gbec",
  authDomain: "netflix-clone-2-23a20.firebaseapp.com",
  projectId: "netflix-clone-2-23a20",
  storageBucket: "netflix-clone-2-23a20.appspot.com",
  messagingSenderId: "979455839373",
  appId: "1:979455839373:web:81fc043913d5851daaa6c4"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };